export default __webpack_public_path__ + "static/media/flooring2.4132df55.jpeg";